export const serverUrl = 'http://localhost:5001'



export const liveServerUrl = 'https://deshiagrofoodsbackend.vercel.app'

